// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SelectShippingAddressDialog-module-addressDialog-3o39->div>div{justify-content:center}.SelectShippingAddressDialog-module-addressDialog-3o39->div>div>*{width:calc(100% - 88px);margin-inline:auto}@media(min-width: 960px){.SelectShippingAddressDialog-module-addressDialog-3o39->div>div>*{width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addressDialog": "SelectShippingAddressDialog-module-addressDialog-3o39-"
};
export default ___CSS_LOADER_EXPORT___;
